export const GET_EVENT_INFO_SUCCESS = 'GET_EVENT_INFO_SUCCESS';
export const GET_EVENT_INFO_ERROR = 'GET_EVENT_INFO_ERROR';
export const GET_GRAND_EVENT_INFO_SUCCESS = 'GET_GRAND_EVENT_INFO_SUCCESS';
export const GET_GRAND_EVENT_INFO_ERROR = 'GET_GRAND_EVENT_INFO_ERROR';
export const UPDATE_WEB_VIEW_STATUS = 'UPDATE_WEB_VIEW_STATUS';
